<template>
    <div class="menu-bg-trial">
        <img class="logo" src="../assets/images/logo.png" />
        <div class="tab">
            <div v-for="(item, index) in tabList" :key="index" @click="setTab(index)" class="flex fd align-center">
                <a class="tab-item" @click="toHerf(item.url)" style="cursor:pointer"
                    :style="{ fontWeight: tabIndex == index ? '600' : '500' }">{{
                        item.label }}</a>
                <div :style="{ display: tabIndex == index ? 'block' : 'none' }" class="active-line"></div>
            </div>
            <div v-if="!loginStatus" class="flex fd align-center">
                <el-button type="primary" @click="loginVisible = true" class="login-btn">登录/注册</el-button>
            </div>
            <div v-else class="flex  align-center" style="color: #fff;">
                <el-avatar size="medium" src="https://s.ryqxdata.com/bigdata/img/avatar-report-hall.png"></el-avatar>
                <el-select class="a-slect" v-model="selectValue" @change="changUse" placeholder="个人中心">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="tab-item" v-for="(item, index) in tabList" :key="index">
                    <div>{{ item.label }}</div>
                    <div v-if="tabIndex == index" class="active-line"></div>
                </div> -->
        </div>
        <el-dialog :visible.sync="loginVisible" top="30vh" width="480px" :center="true" :before-close="handleClose">
            <template slot="title">
                <el-tabs v-model="activeName" style="" @tab-click="handleClick">
                    <el-tab-pane label="登录" name="登录"></el-tab-pane>
                    <el-tab-pane label="注册" name="注册"></el-tab-pane>
                </el-tabs>

            </template>
            <el-form v-if="activeName == '登录'" ref="formLogin" :rules="rulesLogin" :model="formLogin" label-width="0px">
                <el-form-item prop="phone">
                    <el-input placeholder="请输入手机号" v-model="formLogin.phone"></el-input>
                </el-form-item>

                <el-form-item prop="password">
                    <el-input placeholder="请输入密码" v-model="formLogin.password" show-password></el-input>
                </el-form-item>
                <a @click="(loginVisible = false, pwdVisible = true)" class="forget-pwd">忘记密码？</a>
            </el-form>
            <el-form v-else ref="formRegister" :model="formRegister" :rules="rulesRegister" label-width="0px">
                <el-form-item prop="phone">
                    <el-input placeholder="请输入手机号" v-model="formRegister.phone"></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                    <el-input placeholder="请输入验证码" v-model="formRegister.code">
                        <el-button slot="suffix" @click="getCode" type="primary" size="mini" plain>{{ content }}</el-button>
                    </el-input>
                </el-form-item>

                <el-form-item prop="password">
                    <el-input placeholder="请设置密码" v-model="formRegister.password" show-password></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input placeholder="请重复密码" v-model="formRegister.secondPassword" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" v-if="activeName == '登录'" class="dialog-footer">
                <el-button class="logins-btn" type="primary" @click="loginForm('formLogin')">立即登录</el-button>
            </span>
            <span slot="footer" v-else class="dialog-footer">
                <el-button class="logins-btn" type="primary" @click="registerForm('formRegister')">立即注册</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="pwdVisible" top="30vh" width="480px" :before-close="handleClose">
            <template slot="title">
                <span v-if="pwdStatus == 1" style="text-align: left;width: 100%;padding-left: 25px;"
                    class="pwd-title">找回密码</span>
                <span v-else style="text-align: left;width: 100%;padding-left: 25px;" class="pwd-title">重置密码</span>
            </template>
            <el-form v-if="pwdStatus == 1" ref="formForgetPwd" :model="formForgetPwd" style="margin-top: 24px;"
                :rules="rulesPwd" label-width="0px">
                <el-form-item prop="toSend">
                    <el-input placeholder="请输入注册手机号" v-model="formForgetPwd.toSend"></el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input placeholder="请输入验证码" v-model="formForgetPwd.code">
                        <el-button slot="suffix" @click="getPwdCode" type="primary" size="mini" plain>{{ content
                        }}</el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <el-form v-else ref="formForgetPwd" :model="formForgetPwd" style="margin-top: 24px;" :rules="rulesPwd"
                label-width="0px">
                <el-form-item prop="newPassword">
                    <el-input placeholder="请输入新密码" v-model="formForgetPwd.newPassword" show-password></el-input>
                </el-form-item>
                <el-form-item prop="newPasswords">
                    <el-input placeholder="请重复密码" v-model="formForgetPwd.newPasswords" show-password></el-input>
                </el-form-item>
            </el-form>
            <div v-if="pwdStatus == 1" slot="footer" class="dialog-footer flex fd align-center" style="margin-top: 22px;">
                <el-button class="logins-btn" type="primary" @click="retrievePwd('formForgetPwd')">找回密码</el-button>
                <a class="back-login" @click="(loginVisible = true, pwdVisible = false)"><i
                        class="el-icon-back"></i>返回登录</a>
            </div>
            <div v-else slot="footer" class="dialog-footer flex fd align-center" style="margin-top: 22px;">
                <el-button class="logins-btn" type="primary" @click="resettingPwd('formForgetPwd')">确认提交</el-button>
                <a class="back-login" @click="(loginVisible = true, pwdVisible = false)"><i
                        class="el-icon-back"></i>返回登录</a>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    inject: ['reload'],
    data() {
        return {
            tabList: [{
                url: 'http://www.ryqxdata.com/',
                label: '首页'
            }, {
                url: 'http://www.ryqxdata.com/article/lists/id/126.html',
                label: '数字产品'
            }, {
                url: 'http://www.ryqxdata.com/article/lists/id/131.html',
                label: '解决方案'
            }, {
                url: 'http://www.ryqxdata.com/article/lists/id/134.html',
                label: '全链条服务'
            }, {
                url: 'http://www.ryqxdata.com/article/lists/id/140.html',
                label: '干货集锦'
            }, {
                url: 'http://www.ryqxdata.com/article/lists/id/137.html',
                label: '关于我们'
            }],
            tabIndex: 3,
            loginVisible: false,
            activeName: '登录',
            formLogin: {
                phone: '',
                password: ''
            },
            formRegister: {
                phone: '',
                password: '',
                secondPassword: '',
                code: '',
                toSend: '',
            },
            formForgetPwd: {
                toSend: '',
                code: '',
                changeUser: '',
                newPassword: '',
                newPasswords: ''
            },
            pwdStatus: 1,
            rulesLogin: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
            },
            rulesRegister: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                secondPassword: [
                    { required: true, message: '请重复密码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
            },
            rulesPwd: {
                toSend: [
                    { required: true, message: '请输入注册手机号', trigger: 'blur' },
                ],
                newPassword: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                newPasswords: [
                    { required: true, message: '请重复密码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
            },
            content: "获取验证码",
            totalTime: 60, //倒计时
            canClick: true,
            pwdVisible: false,
            loginStatus: false,
            selectValue: '',
            options: [{
                value: '个人中心',
                label: '个人中心'
            }, {
                value: '修改密码',
                label: '修改密码'
            }, {
                value: '退出登录',
                label: '退出登录'
            }]
        }
    },
    created() {
        if (this.$store.state.userId) {
            this.loginStatus = true
        } else {
            this.loginStatus = false
        }
    },
    methods: {
        setTab(index) {
            this.tabIndex = index
        },
        handleClose() {
            this.loginVisible = false
            this.pwdVisible = false
        },
        handleClick(e) {
            this.activeName = e.label
        },
        // 登录
        loginForm(formName) {
            let that = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.apis.login(that.formLogin).then(res => {
                        if (res.code == 0) {
                            that.$store.commit("userIdlist", res.data.userId);
                            that.loginVisible = false
                            this.loginStatus = true
                            that.reload()
                        } else {
                            that.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: '请输入完整信息',
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        // 获取验证码
        getCode() {

            if (this.formRegister.phone == '') {
                this.$message({
                    message: '请输入手机号码',
                    type: 'warning'
                });
            } else {
                let data = {
                    phone: this.formRegister.phone,
                    type: 'register'
                }
                this.sendCode(data)
            }

        },
        sendCode(data) {
            let that = this
            if (!this.canClick) {
                return;
            } //节流


            this.canClick = false;
            this.content = this.totalTime + "s后重新发送";
            let clock = window.setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + "s后重新发送";
                if (this.totalTime < 0) {
                    //当倒计时小于0时清除定时器
                    window.clearInterval(clock); //关闭
                    this.content = "重新发送验证码";
                    this.totalTime = 60;
                    this.canClick = true; //这里重新开启
                }
            }, 1000);
            that.apis.sendSms(data).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                    window.clearInterval(clock);
                    this.content = "重新发送验证码";
                    this.totalTime = 60;
                    this.canClick = true; //这里重新开启
                }
            })
        },
        // 注册
        registerForm(formName) {
            let that = this
            this.formRegister.toSend = this.formRegister.phone
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.apis.checkCode(that.formRegister).then(res => {
                        if (res.code == 0) {
                            that.apis.register(that.formRegister).then(re => {
                                if (re.code == 0) {
                                    this.$message({
                                        message: '注册成果，请登录',
                                        type: 'success'
                                    });
                                    that.activeName = '登录'
                                }
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: '请输入完整信息',
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        // 找回密码短信验证
        getPwdCode() {
            if (this.formForgetPwd.toSend == '') {
                this.$message({
                    message: '请输入手机号码',
                    type: 'warning'
                });
            } else {
                let data = {
                    phone: this.formForgetPwd.toSend,
                    type: 'password'
                }
                this.sendCode(data)
            }
        },
        // 找回密码
        retrievePwd(formName) {
            let that = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.apis.checkCode(that.formForgetPwd).then(res => {
                        if (res.code == 0) {
                            that.pwdStatus = 2
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: '请输入完整信息',
                        type: 'warning'
                    });
                    return false;
                }
            })

        },
        // 重置密码
        resettingPwd(formName) {
            let that = this
            that.formForgetPwd.changeUser = that.formForgetPwd.toSend
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.apis.resetPassword(that.formForgetPwd).then(res => {
                        if (res.code == 0) {
                            if (res.code == 0) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                                that.pwdVisible = false
                                that.loginVisible = true
                                that.activeName = '登录'
                            }
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: '请输入完整信息',
                        type: 'warning'
                    });
                    return false;
                }
            })

        },
        changUse(e) {
            if (e == '退出登录') {
                this.$store.commit("userIdlist", '');
                this.$router.push({
                    path: '/',
                })
                this.reload()
            } else if (e == '修改密码') {
                this.$router.push({
                    path: '/password',
                })
            } else if (e == '个人中心') {
                this.$router.push({
                    path: '/user',
                })
            }
        },
        setLoginVisible(e) {
            this.loginVisible = e
        },
        toHerf(url) {
            window.location.href = url;
        }
    }
}

</script>
<style>
.menu-bg-trial {
    width: 100%;
    height: 84px;
    background: #313334;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 0 160px; */
    position: absolute;
    top: 0;
    left: 0;
}

.menu-bg-trial .logo {
    width: 74px;
    height: 58px;
    margin-left: 5%;
}

.tab {
    display: flex;
    margin-right: 5%;
}

.tab .tab-item {
    margin: 0 30px;
    color: #fff;
    font-size: 16px;
    text-decoration: none;
}

.tab .tab2-item {
    color: #838B93;
    font-size: 16px;
    text-decoration: none;
}

.tab .active-line {
    font-size: 16px;
    font-weight: 600;
    border-bottom: 3px solid #fff;
    padding-bottom: 5px;
    width: 30px;
    height: 2px;
    /* display: none; */
}

.tab .active2-line {
    font-size: 16px;
    font-weight: 600;
    border-bottom: 2px solid #3D82F6;
    padding-bottom: 5px;
    width: 30px;
    height: 2px;
    /* display: none; */
}

.login-btn {
    width: 94px;
    height: 34px;
    background: #0047FF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
}

.menu-bg-trial .el-tabs__nav-wrap::after {
    background-color: #fff;
}

.menu-bg-trial .el-dialog__header {
    display: flex;
    justify-content: center;
}

.menu-bg-trial .el-tabs__item.is-active {
    color: #3D82F6;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    border-bottom: 2px solid #3D82F7;
    height: 32px;
}

.menu-bg-trial .el-tabs__item {
    font-size: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #838B93;
    line-height: 28px;
    padding: 0;
}

.menu-bg-trial .el-tabs__item:last-child {
    margin-left: 36px;
}

.menu-bg-trial .el-dialog__body {
    padding: 0 51px;
}

.menu-bg-trial .logins-btn {
    width: 378px;
    height: 48px;
    background: #3D82F6;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
}

.menu-bg-trial .dialog-footer {
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
}

.menu-bg-trial .el-tabs__active-bar {
    background-color: #fff;
}

.menu-bg-trial .forget-pwd {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D82F7;
    line-height: 16px;
    display: block;
    width: 100%;
    display: flex;
    justify-content: end;
    margin-top: -10px;
    margin-bottom: 20px;
}

.pwd-title {
    font-size: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #242627;
    line-height: 28px;
}

.back-login {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #838B93;
    line-height: 16px;
    margin-top: 16px;
}

.a-slect {
    width: 114px;
}

.a-slect .el-input__inner {
    background-color: rgba(0, 0, 0, 0);
    border: none;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/haeder-trial.vue